<div #stageContainer class="stage-container" >
  <ko-stage (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp()" [config]="configStage"  [ngStyle]="{'cursor': !!mode() ? 'crosshair' : 'default' }">
    <ko-layer #layer>
      <ko-image (click)="handleStageClick()" (mousedown)="onMouseDown($event)" [config]="configImage" ></ko-image>

      <ko-transformer #transformer></ko-transformer>
      @for (arrow of (arrows$ | async); track i; let i = $index) {
        <ko-arrow
          #arrow
          (click)="handleShapeClick($event)"
          [config]="arrow">
        </ko-arrow>
      }

      @for (text of (texts$ | async); track i; let i = $index) {
        <ko-text (click)="handleShapeClick($event)" (dragend)="onDragEndText($event)"  [config]="text"></ko-text>
      }

      @for (line of (lines$ | async); track i; let i = $index) {
        <ko-line (click)="handleShapeClick($event)" [config]="line"></ko-line>
      }

      @for (rect of (rectangle$ | async); track i; let i = $index) {
        <ko-rect
          (click)="handleShapeClick($event)"
          [config]="rect">
        </ko-rect>
      }
    </ko-layer>

  </ko-stage>
</div>
